import PropTypes from 'prop-types';
import React, { useEffect, Suspense } from "react";
import { BRANCH_OWNER } from "./constants/roles";

import { Switch, BrowserRouter as Router, Route, useLocation, useHistory } from "react-router-dom";
import { connect } from "react-redux";

// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes";

// Import all middleware
import Authmiddleware from "./routes/route";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import "./assets/scss/theme.scss";
import { ToastContainer, toast } from 'react-toastify';

// Import 404 page
import Pages404 from "./pages/Utility/pages-404";
import ErrorBoundary from "./components/ErrorBoundary";
import { generateFCMToken } from 'helpers/fcm_helper';
import { updateFCMToken } from 'helpers/services/auth.service';
import { getDecodedFromBackend } from 'common/helper';

const App = props => {
  const location = useLocation();
  const history = useHistory();

  function getLayout() {
    let layoutCls = VerticalLayout;
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = VerticalLayout;// HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const Layout = getLayout();

  useEffect(() => {
    handleGenerateToken();
  }, []);

  const handleGenerateToken = async () => {
    try {
      const fcmToken = await generateFCMToken();
    } catch (error) {
      console.error('Error generating FCM token:', error);
    }
  };

  useEffect(() => {
    let authUser = localStorage.getItem("authUser");
    if (authUser) {
      const role = getDecodedFromBackend(localStorage.getItem("role"));
      const loginStatus = localStorage.getItem("login_status");
      
      if (role === BRANCH_OWNER && loginStatus == "false" && !window.location.href.includes("/admin/change-password")) {
        window.location.href = "/admin/change-password";
      }
    }
  }, [location, history, window.location.href])

  return (
    <React.Fragment>
      <ErrorBoundary>
      <Router>
        <ToastContainer />
        <Suspense fallback={<div className="page-loading">Loading...</div>}>
        <Switch>
          {publicRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
              exact
            />
          ))}

          {authProtectedRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={true}
              exact={route.exact}
            />
          ))}

          {/* Add fallback 404 route when no other routes match */}
          <Route
            render={props => {
              // Check if user is authenticated to determine which layout to use
              const isAuthenticated = localStorage.getItem("authUser");
              return isAuthenticated ? (
                <Layout>
                  <Pages404 {...props} auth={true} />
                </Layout>
              ) : (
                <NonAuthLayout>
                  <Pages404 {...props} auth={false} />
                </NonAuthLayout>
              );
            }}
          />
        </Switch>
        </Suspense>
      </Router>
      </ErrorBoundary>
    </React.Fragment>

  );
};

App.propTypes = {
  layout: PropTypes.any
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);

